var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "details-view", staticStyle: { overflow: "auto" } },
        [
          !_vm.isDialog
            ? _c(
                "div",
                [
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Cancel" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Save" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveDraft")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Save" },
                          on: { click: _vm.publishDirectly }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_PublishDirectly"))
                          )
                        ]
                      )
                    : _vm._e(),
                  !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Back" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("back")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                      )
                    : _vm._e(),
                  !_vm.look && !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.form.status ===
                              _vm.SystemConstants.PRICE_STATUS_NORMAL.code,
                            type: "primary",
                            no: "Edit"
                          },
                          on: { click: _vm.edit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { width: "fit-content", "margin-top": "5px" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "900px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PortPreRateCode")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { value: _vm.form.priceNo, disabled: "" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Pricing.PriceType"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: {
                                  change: function($event) {
                                    _vm.form.branchLine =
                                      _vm.form.priceMethod ===
                                      _vm.SystemConstants.PRICE_METHOD_DIRECT
                                        .code
                                        ? 0
                                        : _vm.form.branchLine
                                  }
                                },
                                model: {
                                  value: _vm.form.priceMethod,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "priceMethod", $$v)
                                  },
                                  expression: "form.priceMethod"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants.PRICE_METHOD_DIRECT
                                          .code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_DirectHaul")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { "margin-right": "5px" },
                                    attrs: {
                                      label:
                                        _vm.SystemConstants.PRICE_METHOD_BRANCH
                                          .code
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_SideLine"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.form.priceMethod ===
                        _vm.SystemConstants.PRICE_METHOD_BRANCH.code
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_SideLineType"),
                                  required: ""
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "branchLine",
                                    "tag-value": "code",
                                    filterable: "",
                                    clearable: false,
                                    "default-value": _vm.form.branchLine,
                                    "static-options":
                                      _vm.SystemConstants.BRANCH_LINES
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.branchLine = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_OriginAreaSelection"
                              ),
                              "label-width": "140px",
                              required: ""
                            }
                          },
                          [
                            _vm.isEdit
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: { click: _vm.addArea }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("CargoMsg.Cargo_AddArea"))
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._l(_vm.form.priceRegions, function(
                          priceRegion,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "form-item-200",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    inline: true,
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-top": "5px"
                                      }
                                    },
                                    [
                                      _c("cargo-area", {
                                        staticStyle: {
                                          display: "inline-block"
                                        },
                                        attrs: {
                                          no: "area",
                                          country: "CN",
                                          province: priceRegion.province,
                                          city: priceRegion.city,
                                          district: priceRegion.districts,
                                          town: priceRegion.townUuid,
                                          "show-town": true,
                                          "select-width": 150
                                        },
                                        on: {
                                          "update:province": function($event) {
                                            return _vm.$set(
                                              priceRegion,
                                              "province",
                                              $event
                                            )
                                          },
                                          "update:city": function($event) {
                                            return _vm.$set(
                                              priceRegion,
                                              "city",
                                              $event
                                            )
                                          },
                                          "update:district": function($event) {
                                            return _vm.$set(
                                              priceRegion,
                                              "districts",
                                              $event
                                            )
                                          },
                                          "update:town": function($event) {
                                            return _vm.$set(
                                              priceRegion,
                                              "townUuid",
                                              $event
                                            )
                                          }
                                        }
                                      }),
                                      _vm.isEdit
                                        ? _c("i", {
                                            staticClass: "el-icon-remove",
                                            staticStyle: {
                                              color: "#f56c6c",
                                              cursor: "pointer",
                                              "margin-top": "5px",
                                              "font-size": "18px"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.delArea(index)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Partners.detailAddress")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: 3 },
                                    model: {
                                      value: priceRegion.detailAddress,
                                      callback: function($$v) {
                                        _vm.$set(
                                          priceRegion,
                                          "detailAddress",
                                          $$v
                                        )
                                      },
                                      expression: "priceRegion.detailAddress"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "603px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_OriginPortInfo"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_POL"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-tabs",
                              {
                                on: {
                                  "tab-click": function($event) {
                                    _vm.form.pol = ""
                                  }
                                },
                                model: {
                                  value: _vm.form.portType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "portType", $$v)
                                  },
                                  expression: "form.portType"
                                }
                              },
                              [
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Harbour"),
                                    name:
                                      _vm.SystemConstants.PORT_TYPE_SEAPORT.code
                                  }
                                }),
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Airport"),
                                    name:
                                      _vm.SystemConstants.PORT_TYPE_AIRPORT.code
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.form.portType ===
                            _vm.SystemConstants.PORT_TYPE_SEAPORT.code
                              ? _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-value": _vm.form.pol
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.pol = p.value)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.form.portType ===
                            _vm.SystemConstants.PORT_TYPE_AIRPORT.code
                              ? _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Airport,
                                    filterable: "",
                                    "default-value": _vm.form.pol
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.pol = p.value)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.Wharf") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.form.wharf,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "wharf", $$v)
                                },
                                expression: "form.wharf"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Vendor") } },
                          [
                            _c("cargo-company-select", {
                              ref: "supplier",
                              attrs: {
                                no: "supplier",
                                "method-params": {
                                  active: true,
                                  subCondition: {
                                    seaCmp: true,
                                    truckCmp: true,
                                    collectionType: "or"
                                  }
                                },
                                "default-value": _vm.form.supplier || 0
                              },
                              on: {
                                change: function(p) {
                                  _vm.form.supplier = p.value || 0
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Pricing.BeginDate"),
                              required: ""
                            }
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.form.endDate &&
                                      time.getTime() >=
                                        new Date(
                                          _vm.form.endDate.length <= 10
                                            ? _vm.form.endDate + " 00:00:00"
                                            : _vm.form.endDate
                                        ).getTime()
                                    )
                                  }
                                }
                              },
                              model: {
                                value: _vm.form.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "beginDate", $$v)
                                },
                                expression: "form.beginDate"
                              }
                            }),
                            _vm._v(" - "),
                            _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.form.beginDate &&
                                      time.getTime() <=
                                        new Date(
                                          _vm.form.beginDate.length <= 10
                                            ? _vm.form.beginDate + " 00:00:00"
                                            : _vm.form.beginDate
                                        ).getTime()
                                    )
                                  }
                                }
                              },
                              model: {
                                value: _vm.form.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "endDate", $$v)
                                },
                                expression: "form.endDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: _vm.form.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remarks", $$v)
                                },
                                expression: "form.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "section", staticStyle: { width: "100%" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("Pricing.PriceInfo")))
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ChargeByContainerType"))
                    )
                  ]),
                  _vm.isEdit
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.delChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _c("cargo-ag-grid-wrapper", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "config-module": "2025050222",
                          "grid-options": _vm.chargingItemByEqSize.gridOptions,
                          "column-defs": _vm.getColumnDefsByEqSize,
                          "row-data": _vm.form.byEqSizeChargingItems,
                          "show-selected-color": false,
                          "check-sub-record": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.chargingItemByEqSize.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ChargeNotByContainerType"))
                    )
                  ]),
                  _vm.isEdit
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.delChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _c("cargo-ag-grid-wrapper", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "config-module": "2025050223",
                          "grid-options":
                            _vm.chargingItemNotByEqSize.gridOptions,
                          "column-defs": _vm.getColumnDefsNotByEqSize,
                          "row-data": _vm.form.notByEqSizeChargingItems,
                          "show-selected-color": false,
                          "check-sub-record": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.chargingItemNotByEqSize.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }